/**
 * @file React hook — useA3Prefill.ts: form/state logic for contributor dashboard.
 */

import type {
  FormDataResponse,
  FormSubSection,
} from "../../../../../../interfaces/formInterfaces";
import { buildA3ValuesFromSubmission } from "../utils/a3ApiFormPrefill";

interface PrefillResult {
  values: Record<string, string>;
  energyTotal: number;
  carbonTotal: number;
}

/**
 * Map saved A3 submission rows (Prisma column names) into CMS form field keys
 * for Dataset Overview and other read-only views.
 */
export function useA3Prefill(
  sections: FormSubSection[],
  submission: Record<string, unknown>,
  backgroundRawMaterialOptions: Array<{ id: number; name: string }> = [],
  formData?: FormDataResponse | null
): PrefillResult {
  return buildA3ValuesFromSubmission({
    sections,
    submission,
    backgroundRawMaterialOptions,
    formData,
  });
}
